angular.module('wbDashboard')
.controller('MilestoneModNewCarController', ['$scope',
function ($scope) {
    //simple pages: ['name', 'purpose', 'date', 'price', 'amount']

    angular.copy(['purpose', 'date', 'price', 'amount',
        'portfolio-type', 'cash-amount', 'portfolios', 'portfolio-confirm',
        'allocation-start', 'cash-amount-end', 'allocation-end', 'review-glide',
        // 'initial-deposit', 'auto-deposit'
    ], $scope.pages);

    if ($scope.mod.action === "create" || !['simple', 'auto-deposit', 'portfolio-type', 'portfolio-simple-type', 'allocation-start', 'confirm'].includes($scope.$stateParams.page)) {
        $scope.goToPage($scope.pages[0]);
    }

    $scope.mod.extra.getNextPage = function() {
        var page = null;
        var pageIndex = $scope.pages.indexOf($scope.$stateParams.page);

        //noinspection FallThroughInSwitchStatementJS
        switch ($scope.$stateParams.page) {
            default:
                break;
        }
        return page;
    };


    $scope.purposes = [
        "Yes",
        "No, I'm trading for a new one",
        "No, I'm adding to my fleet",
        "Other"
    ];

    $scope.amountValidation = function() {
        /*jshint -W018 */
        return {
            min: function($value) { return !(($value!==null) && $value < $scope.milestone.metadata.purchase_price * 0.01); },
        };
        /*jshint +W018 */
    };

    $scope.amountValidationMessage = function() {
        var message = "$" + ($scope.milestone.metadata.purchase_price * 0.01).toFixed() + "min, $99,999,999 max";
        return {
            min: message,
            max: message
        };
    };


}]);
